var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.active)?_c('div',{directives:[{name:"on-clickaway",rawName:"v-on-clickaway",value:(_vm.hide),expression:"hide"}],staticClass:"c-popover",style:(_vm.styles)},[_vm._t("default",null,{"actions":{ toggle: _vm.toggle, show: _vm.show, hide: _vm.hide },"data":_vm.data})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }